<!--
     Copyright (c) 2022-2024 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->
<clr-vertical-nav [clrVerticalNavCollapsible]="true"
                  [(clrVerticalNavCollapsed)]="collapsed"
                  role="navigation"
                  [vmwNgxVerticalNavAutoCollapse]=VERTICAL_NAV_AUTO_COLLAPSE_WIDTH>
    <ng-container *ngFor="let navItem of navItems">
        <ng-container *requiredPrivileges="navItem.requiredPrivileges">
            <vertical-nav-item *ngIf="!navItem.childItems"
                               [navItem]="navItem">
            </vertical-nav-item>
            <clr-vertical-nav-group *ngIf="navItem.childItems"
                                    class="nav-group">
                <a clrVerticalNavLink
                   [routerLink]="navItem.routerLink"
                   [routerLinkActive]="'active'"
                   [routerLinkActiveOptions]="{ exact: true }"
                   class="nav-link"
                   dr-set-aria-current
                   dr-show-title>
                    <cds-icon *ngIf="navItem.iconShape" clrVerticalNavIcon
                              [attr.shape]="navItem.iconShape"
                              [attr.aria-hidden]="true"
                              size="sm">
                    </cds-icon>
                    {{ navItem.l10nKey | vtranslate }}
                </a>
                <clr-vertical-nav-group-children *clrIfExpanded="true">
                    <div *ngFor="let childItem of navItem.childItems">
                        <vertical-nav-item [navItem]="childItem"
                                           *requiredPrivileges="childItem.requiredPrivileges"
                                           routerLinkActive="active">
                        </vertical-nav-item>
                        <clr-vertical-nav-group *ngIf="childItem.childItems"
                                                routerLinkActive="active">
                            <cds-icon *ngIf="childItem.iconShape" clrVerticalNavIcon
                                      [attr.shape]="childItem.iconShape"
                                      [attr.aria-hidden]="true"
                                      size="sm"
                                      class="nav-sub-group">
                            </cds-icon>
                            {{ childItem.l10nKey | vtranslate }}
                            <clr-vertical-nav-group-children *clrIfExpanded="true"
                                                             routerLinkActive="active">
                                <div *ngFor="let subChildItem of childItem.childItems">
                                    <vertical-nav-item [navItem]="subChildItem"
                                                       *requiredPrivileges="subChildItem.requiredPrivileges"
                                                       [subItemStyle]=true>
                                    </vertical-nav-item>
                                </div>
                            </clr-vertical-nav-group-children>
                        </clr-vertical-nav-group>
                    </div>
                </clr-vertical-nav-group-children>
            </clr-vertical-nav-group>
        </ng-container>
    </ng-container>
</clr-vertical-nav>

<ng-content *ngIf="!collapsed"></ng-content>
